import config from 'config/index';
import { API_ROUTES, LOCALSTORAGE_KEYS } from 'utils/globalVariable';
import { callApi, getItem, getHotelId } from 'utils/globalFunction';
import { GridReportViewThresholdComparator } from 'components/GridReport/models';

export const getGridReports = async (postData: any = {}): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const gridReports = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report`,
      postData,
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (gridReports?.data?.data?.gridReports) {
      return gridReports.data.data.gridReports;
    } else {
      return [];
    }
  } catch (error: any) {
    return [];
  }
};

export const getGridReportById = async (reportId: string): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const gridReport = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report/${reportId}`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );

    if (gridReport?.data?.data?.gridReport) {
      return gridReport.data.data.gridReport;
    } else {
      return [];
    }
  } catch (error: any) {
    return [];
  }
};

export const createGridReport = async (): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const gridReport = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report`,
      {},
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return gridReport?.data?.data?.gridReport;
  } catch (error: any) {
    return [];
  }
};

export const addGridReportView = async (
  reportId: string,
  metric: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const gridReport = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report/${reportId}/view`,
      { metric },
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return gridReport?.data?.data;
  } catch (error: any) {
    return [];
  }
};

export const getGridReportViewById = async (
  gridReportViewId: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const gridReportView = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report-view/${gridReportViewId}`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return gridReportView?.data?.data;
  } catch (error: any) {
    return null;
  }
};

export const updateGridReportView = async (
  gridReportViewId: string,
  data: any,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const gridReportView = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report-view/${gridReportViewId}`,
      data,
      'put',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return gridReportView?.data?.data;
  } catch (error: any) {
    return [];
  }
};

export const getGridReportViewThresholds = async (
  gridReportViewId: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const thresholds = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report-view/${gridReportViewId}/threshold`,
      {},
      'get',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    if (thresholds?.data?.data?.gridReportViewThresholds) {
      return thresholds.data.data.gridReportViewThresholds;
    } else {
      return [];
    }
  } catch (error: any) {
    return [];
  }
};

export const createGridReportViewThreshold = async (
  gridReportViewId: string,
  thresholdData: {
    color: string;
    label: string;
    comparator: GridReportViewThresholdComparator;
    value: number;
    secondValue?: number;
  },
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const threshold = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report-view/${gridReportViewId}/threshold`,
      thresholdData,
      'post',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return threshold?.data?.data?.gridReportViewThreshold;
  } catch (error: any) {
    return null;
  }
};

export const updateGridReportViewThreshold = async (
  gridReportViewId: string,
  thresholdId: string,
  thresholdData: {
    color?: string;
    label?: string;
    comparator?: GridReportViewThresholdComparator;
    value?: number;
    secondValue?: number;
  },
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const threshold = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report-view/${gridReportViewId}/threshold/${thresholdId}`,
      thresholdData,
      'put',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return threshold?.data?.data?.gridReportViewThreshold;
  } catch (error: any) {
    return null;
  }
};

export const deleteGridReportViewThreshold = async (
  gridReportViewId: string,
  thresholdId: string,
): Promise<boolean> => {
  try {
    const hotelId = getHotelId() as string;
    const response = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report-view/${gridReportViewId}/threshold/${thresholdId}`,
      {},
      'delete',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return response?.status === 200;
  } catch (error: any) {
    return false;
  }
};

export const updateGridReportName = async (
  gridReportId: string,
  name: string,
): Promise<any> => {
  try {
    const hotelId = getHotelId() as string;
    const response = await callApi(
      `${config.REACT_APP_BASE_URL}${API_ROUTES.baseWorkspaceUrl}/${hotelId}/grid-report/${gridReportId}`,
      { name },
      'patch',
      true,
      false,
      getItem(LOCALSTORAGE_KEYS.ACCESS_TOKEN),
      '',
      false,
    );
    return response?.status === 200;
  } catch (error: any) {
    console.log(error);
    return false;
  }
};
